import React from 'react';
import {
    CircularProgress,
    Paper,
    Typography,
} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import RefreshIcon from '@material-ui/icons/Refresh';
import MaterialTable from 'material-table';
import useStyles from '../styles/styles';
import {useQuery} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import TableIcons from '../utils/TableIcons';

const JvmStats = () => {
    const classes = useStyles();
    /**
     * Fetch JVM Status
     */
    const {loading, error, data, refetch} = useQuery(gql`
        query AllJvmStats {
            allJvmStats {
                id
                totalMemory
                freeMemory
                maxMemory
                hostAddress
                networkAddressTtl
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
    });

    const JvmStatsTable = () => (
        <MaterialTable
            title=""
            icons={TableIcons}
            columns={[
                {title: "Key", field: "key"},
                {title: "Value", field: "value"}
            ]}
            data={[
                {
                    key: 'Host Address',
                    value: `${data.allJvmStats.hostAddress}`,
                },
                {
                    key: 'Max Memory',
                    value: `${(Math.round(data.allJvmStats.maxMemory * 100) / 100).toFixed(2)} GiB`,
                },
                {
                    key: 'Total Memory',
                    value: `${(Math.round(data.allJvmStats.totalMemory * 100) / 100).toFixed(2)} GiB`,
                },
                {
                    key: 'Free Memory',
                    value: `${(Math.round(data.allJvmStats.freeMemory * 100) / 100).toFixed(2)} GiB`,
                },
                {
                    key: 'Network Address Cache TTL',
                    value: `${data.allJvmStats.networkAddressTtl}`,
                },
            ]}
            actions={[
                {
                    icon: () => <RefreshIcon/>,
                    tooltip: 'Refetch Data',
                    isFreeAction: true,
                    onClick: (event) => refetch()
                }
            ]}
            options={{
                addRowPosition: 'first',
                pageSize: 100,
                pageSizeOptions: [100, 200, 300],
                headerStyle: {
                    minWidth: 'auto',
                },
                search: false
            }}
        />
    );

    return (
        <>
            <Typography variant="h2">
                JVM Stats
            </Typography>
            {!loading && error ? (
                <Paper className={classes.paper}>
                    <Alert severity="error">There is an error!</Alert>
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                </Paper>
            ) : null}
            {loading ? (
                <Paper className={classes.paper}>
                    <div className={classes.loadingBar}>
                        <CircularProgress
                            size={50}
                            thickness={4}
                        />
                    </div>
                </Paper>
            ) : null}
            {!loading && data && data.allJvmStats && data.allJvmStats.totalMemory ? (
                <JvmStatsTable/>
            ) : null}
        </>
    );
};

export default JvmStats;
